// extracted by mini-css-extract-plugin
module.exports =  {"userSelect_none":"_33974c2b58--userSelect_none--g_J_6","userSelect_auto":"_33974c2b58--userSelect_auto--f5UVj","userSelect_all":"_33974c2b58--userSelect_all--v9qxk"};